import React, { useEffect, useState } from "react";
import Modal from "../../../components/modal";
import axios from "axios"; // If you're using axios for API calls
import { API_URL } from "../../../utils/constant";
import Swal from "sweetalert2";

const TenderRawProducts = ({ show, onClose, heading, initialData = {} }) => {
    const [selectedProducts, setSelectedProducts] = useState([]);
    const [tenderId, setTenderId] = useState(0);

    useEffect(() => {
        if (initialData) {
            setTenderId(initialData.id);
            if (initialData?.finalProduct?.finalRawProducts) {
                setSelectedProducts(initialData?.finalProduct?.finalRawProducts);

            }
        }
    }, [initialData]);
    // Calculate the total quantity of raw products (assuming each product has multiple vendors)
    const calculateQuantity = (vendors) => {
        let finalQuantity = 0;
        vendors?.forEach((e) => {
            finalQuantity += e.quantity;
        });

        return finalQuantity;
    };

    const calculateRequired = (total, current) => {
        const requiredQuantity = (initialData.quantity * total) - current;
        if (requiredQuantity < 0) {
            return 0;
        }
        return requiredQuantity;
    };


    const calculateAvgCost = (row) => {
        console.log(row.RawProductVendors);
        if (Array.isArray(row.RawProductVendors) && row.RawProductVendors.length > 0) {
            // Find the RawProductVendor with the lowest purchase_cost
            const lowestCostVendor = row.RawProductVendors.reduce((minVendor, vendor) => 
                vendor.purchase_cost < minVendor.purchase_cost ? vendor : minVendor
            );
            // Calculate the average cost for the selected vendor
            const averageCost = lowestCostVendor.purchase_cost; 
            return `${averageCost}`; // Format with rupee symbol and 2 decimal places
        } 
        return 'N/A';
    }
    


    return (
        <Modal show={show} onClose={onClose} heading={heading}>
            <div className="col-md-12">
                {selectedProducts &&
                    selectedProducts.map((data, index) => (
                        <div key={index} className="row mb-4 d-flex align-items-center">
                            {/* Hidden input for product ID */}
                            <input
                                type="hidden"
                                name={`product_id_${index}`}
                                value={data.raw_product_id} // Hidden product ID
                            />

                            {/* Product Name */}
                            <div className="col-md-2">
                                <div className="form-group">
                                    <label>Name</label>
                                    <input
                                        type="text"
                                        value={data.rawProducts?.name}
                                        readOnly
                                        className="form-control"
                                    />
                                </div>
                            </div>

                            {/* Current Stock Quantity */}
                            <div className="col-md-2">
                                <div className="form-group">
                                    <label>Required Quantity</label>
                                    <div className="input-group mb-2">
                                        <input
                                            type="text"
                                            value={data?.quantity}
                                            readOnly
                                            className="form-control"
                                        />
                                        <div className="input-group-prepend">
                                            <div className="input-group-text">{data.rawProducts?.RawCategory?.Unit?.name}</div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div className="col-md-3">
                                <div className="form-group">
                                    <label>Average Cost / Unit</label>
                                    <div className="input-group mb-2">
                                        <div className="input-group-prepend">
                                            <div className="input-group-text">₹</div>
                                        </div>
                                        <input
                                            type="text"
                                            value={calculateAvgCost(data?.rawProducts)}
                                            readOnly
                                            className="form-control"
                                        />
                                    </div>
                                </div>
                            </div>
                            <div className="col-md-2">
                                <div className="form-group">
                                    <label>Total Required Quantity</label>
                                    <input
                                        type="text"
                                        value={calculateRequired(data?.quantity, calculateQuantity(data.rawProducts?.RawProductVendors))}
                                        readOnly
                                        className="form-control"
                                    />
                                </div>
                            </div>

                            {/* Current Stock Quantity */}
                            <div className="col-md-3">
                                <div className="form-group">
                                    <label>Current Stock</label>
                                    <input
                                        type="text"
                                        value={calculateQuantity(data.rawProducts?.RawProductVendors)}
                                        readOnly
                                        className="form-control"
                                    />
                                </div>
                            </div>

                            {/* Required Quantity */}
                            
                        </div>
                    ))
                }

            </div>
        </Modal>
    );
};

export default TenderRawProducts;
